import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterTag_template } from "./filterTag_template";
import { vignettePreview_template } from "./vignettePreview_template";

declare var ko: any;

export class vignettesEdit_template extends vnTemplate {
    protected tagFilter: filterTag_template;
    protected vignettePreview: vignettePreview_template;

    protected getTemplateHtml(): string {
        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <h3 class="form-title icon i-summary" data-bind="vtext: name">Vignette Editor</h3>

                    <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                            <label class="form-label">Name</label>
                            <div class="w-input">
                                <input type="text" name="name" id="name"  class="input-text" data-bind="value: name">
                            </div>
                        </div>
                    </div>
                    <div class="form-body">
                        <div class="form-group">

                            <table class="list-action" style="margin: 0;">
                                <tr>
                                    <td><label for="" class="form-label">Tag Name</label></td>
                                    <td><span type="button">[[default_name]]</span></td>
                                </tr>
                                <tr>
                                    <td><label for="" class="form-label">Image</label></td>
                                    <td><span type="button">[[default_image_url]]</span></td>
                                </tr>
                                <tr>
                                    <td><label for="" class="form-label">Icon</label></td>
                                    <td><span type="button">[[default_icon_url]]</span></td>
                                </tr>
                                <tr>
                                    <td><label for="" class="form-label">Color</label></td>
                                    <td><span type="button">[[default_color]]</span></td>
                                </tr>
                                <tr>
                                    <td><label for="" class="form-label">Tag Type</label></td>
                                    <td><span type="button">[[default_tag_type]]</span></td>
                                </tr>
                                <tr>
                                    <td><label for="" class="form-label">Dataset</label></td>
                                    <td><span type="button">[[default_dataset]]</span></td>
                                </tr>
                                <tr>
                                    <td><label for="" class="form-label">SEO Description</label></td>
                                    <td><span type="button">[[default_seo_description]]</span></td>
                                </tr>
                                <tr>
                                    <td><label for="" class="form-label">Review Score</label></td>
                                    <td><span type="button">[[default_review_score]]</span></td>
                                </tr>
                                <tr>
                                    <td><label for="" class="form-label">Description</label></td>
                                    <td><span type="button">[[default_description]]</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>


                <div class="w-form-body">

                    <div class="form-body">
                        <strong class="form-sub-title no-margin">HTML</strong>
                        <div class="form-group">
                            <label for="" class="form-label">HTML</label>
                            <textarea style="height: 300px" id="htmlEditor" data-bind="value: html, valueUpdate: 'afterkeydown'"></textarea>
                        </div>
                    </div>
                    <div class="form-body">
                        <strong class="form-sub-title no-margin">CSS</strong>
                        <div class="form-group">
                            <label for="" class="form-label">CSS</label>
                            <textarea style="height: 300px" id="cssEditor" data-bind="value: css, valueUpdate: 'afterkeydown'"></textarea>
                        </div>
                    </div>
                </div>

                <div class="w-form-body">

                    <div class="form-body full-width">
                        <strong class="form-sub-title no-margin">Preview</strong>
                        <div class="form-group" style="width: 40%">
                            ${ this.tagFilter.getHtmlBuild() }
                        </div>
                        <div class="form-group">
                            ${ this.vignettePreview.getHtmlBuild() }
                        </div>
                    </div>

                </div>

                <div class="form-footer">
                    <button type="button" data-bind="event: { click: onClickCancel }" class="btn ">Cancel</button>
                    <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>
                </div>
            </div>
            `;
    }

    protected initPartial(): void {

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.vignettePreview = new vignettePreview_template("vignettePreview", this.getTemplateViewModel(), this.caller);
        this.vignettePreview.setShowKeys(true);
    }

    protected getTemplateName(): string {

        return "vignettesEdit_template";
    }

    protected buildViewModel(): any {

        const self = this;

        return {
            brand: ko.observable(""),
            id: ko.observable(""),
            name: ko.observable(""),
            htmlValue: ko.observable(""),
            html: ko.pureComputed(this.htmlComputed(self)),
            cssValue: ko.observable(""),
            css: ko.pureComputed(this.cssComputed(self)),
            permissions: ko.observableArray(this.initPermissions(['vignettes'])),
            isBrandOwner: ko.pureComputed(() => self.getIsBrandOwner()),
            brandOwner: ko.observable(null),
            onClickCancel: this.onClickCancel.bind(this),
            onClickSave: this.onClickSave.bind(this),
        }
    }

    public getIsBrandOwner = (): boolean => {
        const vm = this.getTemplateViewModel();

        return (vm.brandOwner() && vm.brand())? vm.brandOwner().id == vm.brand() : false;
    }

    public onClickSave(data, event) {
        this.caller.saveVignette();
    }

    public onClickCancel() {
        this.caller.cancel();
    }

    protected htmlComputed(self) {
        return {
            read: function() {
                return self.getTemplateViewModel().htmlValue();
            },
            write: function(value) {
                self.getTemplateViewModel().htmlValue(value);
                self.vignettePreview.setHtml(value);
            }
        }
    }


    protected cssComputed(self) {
        return {
            read: function() {
                return self.getTemplateViewModel().cssValue();
            },
            write: function(value) {
                self.getTemplateViewModel().cssValue(value);
                self.vignettePreview.setCss(value);
            }
        }
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public setVignette(vignette): void {
        this.getTemplateViewModel().id(vignette.id);
        this.getTemplateViewModel().name(vignette.name);
        this.getTemplateViewModel().brandOwner(vignette.brandOwner);
        this.setHtml(vignette.html);
        this.setCss(vignette.css);
    }

    public getViewModelForRequest() {

        return {
            id: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            html: this.getTemplateViewModel().html(),
            css: this.getTemplateViewModel().css(),
        }
    }

    public setHtml(value): void {
        this.getTemplateViewModel().html(value);
    }

    public setCss(value): void {
        this.getTemplateViewModel().css(value);
    }

    public setId(id): void {
        this.getTemplateViewModel().id(id);
    }

    public setBrand(brand): void {

      this.getTemplateViewModel().brand(brand);
    }

    protected setTagFilter(tags) {

        this.getTemplateViewModel().tagFilter.tags(tags);
    }

    public updateTagForPreview() {
        this.caller.getPreviewTag(this.tagFilter.getTemplateViewModel().idTag(), 'previewContainer');
    }

    public setIndexedValues(tag=null, specsValues=[], specDefaults=[]) {
        this.vignettePreview.setShowKeys(!tag || Object.keys(tag).length === 0);
        this.vignettePreview.setIndexedValues(tag, specsValues, specDefaults);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/vignettesEdit_template.ts